/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/10
 * Time: 9:37
 * Desc: 分销策略设置
 */

import { Component, Vue } from 'vue-property-decorator';

// 子组件
import VirtualManageDistribute from '@/views/components/virtualManageDistribute/virtualManageDistribute.vue'; // 虚拟店长分销
import GuiderDistribute from '@/views/components/guiderDistribute/guiderDistribute.vue'; // 导购分销
import NoAuth from '@/views/components/noAuth/noAuth.vue';
@Component({
  components: {
    VirtualManageDistribute,
    GuiderDistribute,
    NoAuth,
  },
})
export default class DistributeStrategySetting extends Vue {
  /* 数据 */

  /**
   * 当前页面的索引
   * @type {string}
   */
  public curPage = '1';

  /**
   * 页面名称
   * @type {ItemObject}
   */
  public pageNameObj: ItemObject = {
    p1: 'VSHOP-FUNCTION-BASIC-DISTRIBUTE-VIRGUIDER',
    p2: 'VSHOP-FUNCTION-BASIC-DISTRIBUTE-GUIDER',
  };

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /* 方法 */

  /**
   * 切换页面
   */
  public onPageSwitch(key): void {
    this.curPage = key;
    this.setCurPageName(key); // 设置当前页索引到缓存
  }

  /**
   * 判断菜单权限
   * @param {string} name
   * @return {boolean}
   */
  public menuAuth(name: string): boolean {
    return this.$store.state.authMenuCodeList.includes(name);
  }

  /**
   * 获取当前页索引
   * @return null
   */
  public getNearCurPage(): void {
    // 找到最近的
    if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p1)) {
      this.curPage = '1';
      localStorage.setItem('curPageName', this.pageNameObj.p1);
    } else if (this.$store.state.authMenuCodeList.includes(this.pageNameObj.p2)) {
      this.curPage = '2';
      localStorage.setItem('curPageName', this.pageNameObj.p2);
    }
    this.setCurPageName(this.curPage);
  }

  /**
   * 菜单名称和索引转换
   * @param {string} val
   * @return null
   */
  public getCurPage(val: string): void {
    switch (val) {
      case this.pageNameObj.p1:
        this.curPage = '1';
        break;
      case this.pageNameObj.p2:
        this.curPage = '2';
        break;
    }
  }

  /**
   * 设置当前页名称
   * @return null
   */
  public setCurPageName(key: string): void {
    // 设置缓存
    switch (key) {
      case '1':
        localStorage.setItem('curPageName', this.pageNameObj.p1);
        break;
      case '2':
        localStorage.setItem('curPageName', this.pageNameObj.p2);
        break;
    }
  }

  /**
   * 设置菜单权限
   * @return null
   */
  public menuAuthSet(): void {
    if (localStorage.getItem('curPageName')) {
      this.getCurPage(localStorage.getItem('curPageName'));
    } else {
      this.getNearCurPage();
    }
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-BASIC-DISTRIBUTE');
    if (this.isContentBodyShow) {
      this.menuAuthSet();
    }
  }
}
